import Vue from 'vue';

export default {
  SET_LAST_FETCH_TIME(state, payload) {
    Vue.set(state, 'lastFetchTime', payload);
  },

  SET_EXTRA_PAYMENTS(state, payload) {
    Vue.set(state, 'extraPayments', payload);
  },

  SET_PAGE_INFO(state, payload) {
    Vue.set(state, 'pageInfo', payload);
  },

  SET_PAYMENT_RESULT(state, result) {
    Vue.set(state, 'paymentResult', result);
  },
};



// WEBPACK FOOTER //
// ./src/views/ExtraPayment/store/mutations.js